import ulog from 'ulog';

ulog.level = ulog.DEBUG;

const Logger = ulog;

export default Logger;
